import { call, select } from 'redux-saga/effects';
import removeIncomingCall from '../../callSessions/removeIncomingCall/removeIncomingCall';
import { selectHeadsetType, selectActiveHeadsetDevice } from '../../../state/userMedia/userMediaSlice';
import { getHeadsetDeviceByLabel } from '../../../utils/devices';

export default function* rejectCall({ payload: { call: callSession, signalHid = true } }) {
  callSession.reject(signalHid);

  // Stop ringing on Yealink headset when call is rejected
  try {
    const headsetType = yield select(selectHeadsetType);
    if (headsetType === 'yealink') {
      const activeDevice = yield select(selectActiveHeadsetDevice);
      const activeDeviceName = activeDevice?.name || activeDevice?.device?.name;
      if (activeDevice && activeDeviceName) {
        const yealinkCallControl = getHeadsetDeviceByLabel(activeDeviceName);
        if (yealinkCallControl && typeof yealinkCallControl.ringOff === 'function') {
          yealinkCallControl.ringOff();
        }
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('rejectCall - Yealink ringOff error:', error);
  }

  yield call(removeIncomingCall, { payload: callSession.id });
}
